import { z } from "zod";
import { DTOEventDataSourcesImported, DTOEventFigmaNodesRendered } from "./design-system";

export const DTOEvent = z.discriminatedUnion("type", [DTOEventDataSourcesImported, DTOEventFigmaNodesRendered]);

export type DTOEvent = z.infer<typeof DTOEvent>;
